import { string } from 'yup';
import { ValidationErrorMessages } from './constants';

export const getVariableNameSchema = ({
  existingNames,
}: {
  existingNames: string[];
}) => {
  return string()
    .required(ValidationErrorMessages.required)
    .max(40, ValidationErrorMessages.contain40)
    .notOneOf(existingNames, ValidationErrorMessages.variableNameExists)
    .matches(/^[a-zA-Z0-9\s_]+$/, ValidationErrorMessages.containSimpleChars)
    .matches(/^[a-zA-Z]/, ValidationErrorMessages.startWithLetter);
};

export const getVariableDescriptionSchema = () => {
  return string().max(80, ValidationErrorMessages.contain80);
};
